import React, { useEffect, useState } from 'react';
import { Phone, Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Our Work',
    href: '#gallery'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-ocean-900/95 backdrop-blur-md shadow-lg py-3' : 'bg-transparent py-5'}`} data-id="element-63">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-64">
        <div className="flex justify-between items-center" data-id="element-65">
          {/* Logo */}
          <a href="#" className="flex items-center gap-3 group" data-id="element-66">
            <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-ocean-400/50 group-hover:border-sun-400 transition-colors" data-id="element-67">
              <img src="https://cdn.magicpatterns.com/uploads/376XfgufppoCzctQV4w12y/bwc_temp_logo.jpg" alt="BWC Logo" className="w-full h-full object-cover" data-id="element-68" />
            </div>
            <span className="text-white font-bold text-xl tracking-wide" data-id="element-69">
              BWC Decking
            </span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-70">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-gray-200 hover:text-sun-400 font-medium transition-colors" data-id="element-71">
                {link.name}
              </a>)}
            <a href="#contact" className="flex items-center gap-2 bg-sun-500 hover:bg-sun-400 text-ocean-900 px-5 py-2.5 rounded-full font-bold transition-all transform hover:scale-105 shadow-lg shadow-sun-500/20" data-id="element-72">
              <Phone size={18} data-id="element-73" />
              <span data-id="element-74">(954) 275-1630</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-75">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-white hover:text-sun-400 p-2" data-id="element-76">
              {mobileMenuOpen ? <X size={28} data-id="element-77" /> : <Menu size={28} data-id="element-78" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-ocean-900 border-t border-ocean-800 shadow-xl" data-id="element-79">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-80">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="block px-3 py-3 text-base font-medium text-gray-200 hover:text-sun-400 hover:bg-ocean-800 rounded-md" data-id="element-81">
                {link.name}
              </a>)}
            <a href="#contact" onClick={() => setMobileMenuOpen(false)} className="mt-4 flex items-center justify-center gap-2 w-full bg-sun-500 text-ocean-900 px-5 py-3 rounded-md font-bold" data-id="element-82">
              <Phone size={18} data-id="element-83" />
              <span data-id="element-84">(954) 275-1630</span>
            </a>
          </div>
        </div>}
    </nav>;
}